const inputKey = {
  clear: "clear"
  ,clearList: "clearList"
  ,clearInput: "clearInput"

  ,open: "open"

  ,search: "search"  //
  ,baidu: "baidu"  //
  ,ecosia: "ecosia"
  ,google: "google"
  ,yahoo: "yahoo"
  ,bing: "bing"
  ,qihu: "qihu"
  ,sougou: "sougou"
  ,soso: "soso"

  ,video: "video"  //
  ,youku: "youku"  //
  ,qqVideo: "qqVideo"
  ,iqiyi: "iqiyi"
  ,bilibili: "bilibili"
  ,mgtv: "mgtv"
  ,sohutv: "sohutv"
  ,le: "le"
  ,acfun: "acfun"
  ,tudou: "tudou"
  ,nico: "nico"
  ,youtube: "youtube"


  ,music: "music"
  ,qqmusic: "qqmusic"
  ,xiamimusic: "xiamimusic"
  ,netmusic: "netmusic"
  ,kugoumusic: "kugoumusic"
  ,youtubemusic: "youtubemusic"
  ,baidumusic: "baidumusic"

  ,mv: "mv"
  ,yinyuetai: "yinyuetai"
  ,qqmusicmv: "qqmusicmv"

  ,play: "play"
  ,playQQMusic: "playQQMusic"

  ,playMv: "playMv"
  ,playQQMusicMv: "playQQMusicMv"

  ,question: "question"
  ,zhihu: "zhihu"
  ,baiduzhidao: "baiduzhidao"

  ,wiki: "wiki"
  ,sougoubaike: "sougoubaike"
  ,baidubaike: "baidubaike"
  ,hudongbaike: "hudongbaike"
  ,qihubaike: "qihubaike"
  ,wikibaike: "wikibaike"
  ,baidubaikeSearch: "baidubaikeSearch"

  ,news: "news"
  ,baiduxinwen: "baiduxinwen"
  ,qqxinwen: "qqxinwen"
  ,sohuxinwen: "sohuxinwen"
  ,sinaxinwen: "sinaxinwen"

  ,buy: "buy"
  ,taobao: "taobao"
  ,tmall: "tmall"
  ,jd: "jd"
  ,amazon: "amazon"
  ,amazoncn: "amazoncn"

  ,code: "code"
  ,github: "github"
  ,oschina: "oschina"
  ,segmentfault: "segmentfault"
  ,stackoverflow:"stackoverflow"

  ,download: "download"  //?


  ,airticket: "airticket"
  ,ctripairticket: "ctripairticket"
  ,feizhuairticket: "feizhuairticket"


  ,trainticket: "trainticket"
  ,ctriptrainticket: "ctriptrainticket"
  ,feizhutrainticket: "feizhutrainticket"



  ,link: "link"


  ,fanyi: "fanyi"

  ,jisuanqi: "jisuanqi"
  ,note: "note"
  ,table: "table"
  ,ppt: "ppt"
  ,mindmap: "mindmap"

  ,express: "express"

  ,qq:"qq"
  ,hao123:"hao123"
  ,sohu:"sohu"
  ,sina: "sina"
  ,googletranslate: "googletranslate"
  ,baiduwenku: "baiduwenku"
  ,baiduwangpan: "baiduwangpan"
  ,yaoyaowu: "yaoyaowu"
  ,xinhuawang: "xinhuawang"
  ,sinablog: "sinablog"
  ,renminribao: "renminribao"
  ,gmw: "gmw"
  ,tianya: "tianya"
  ,youth: "youth"
  ,china: "china"
  ,cctv: "cctv"
  ,alipay: "alipay"
  ,babytree: "babytree"
  ,huanqiu: "huanqiu"
  ,csdn: "csdn"
  ,mamawang: "mamawang"
  ,zol: "zol"
  ,net163: "net163"
  ,douyu: "douyu"
  ,bitauto: "bitauto"
  ,douban: "douban"
  ,caijing: "caijing"
  ,yesky: "yesky"
  ,dianying1905: "dianying1905"
  ,cnnic: "cnnic"
  ,cnblogs: "cnblogs"
  ,zhongguoribao: "zhongguoribao"
  ,alibaba: "alibaba"
  ,apple: "apple"
  ,facebook: "facebook"
  ,microsoft: "microsoft"
  ,dongfangwang: "dongfangwang"
  ,chaoshitmall: "chaoshitmall"
  ,youdaonote: "youdaonote"
  ,hongwang: "hongwang"
  ,instagram: "instagram"
  ,aliyun: "aliyun"
  ,chinaz: "chinaz"
  ,huaban: "huaban"
  ,ifeng: "ifeng"
  ,linkedin: "linkedin"
  ,suning: "suning"
  ,cnmo: "cnmo"
  ,zhanqi: "zhanqi"
  ,k618: "k618"
  ,wuba: "wuba"
  ,stockstar: "stockstar"
  ,jb51: "jb51"
  ,pk52: "pk52"
  ,toutiao: "toutiao"
  ,xunlei: "xunlei"
  ,bbc: "bbc"
  ,twitter: "twitter"
  ,ebay: "ebay"
  ,tumblr: "tumblr"
  ,mi: "mi"
  ,zhaopin: "zhaopin"
  ,ly: "ly"
  ,jia: "jia"
  ,adobe: "adobe"
  ,hupu: "hupu"
  ,jianshu: "jianshu"
  ,mail126: "mail126"
  ,mail163: "mail163"
  ,sisanjiujiu: "sisanjiujiu"
  ,dianping: "dianping"
  ,sandm: "sandm"
  ,gamersky: "gamersky"
  ,duba: "duba"
  ,panda: "panda"
  ,steampowered: "steampowered"
  ,to8to: "to8to"
  ,feng: "feng"
  ,ngacn: "ngacn"
  ,yaoqiyaoqisan: "yaoqiyaoqisan"
  ,wordpress: "wordpress"
  ,cto51: "cto51"
  ,smzdm: "smzdm"
  ,w3school: "w3school"
  ,w3schools: "w3schools"
  ,renren: "renren"
  ,v2ex: "v2ex"
  ,runoob: "runoob"
  ,paypal: "paypal"
  ,tieba: "tieba"
  ,gome: "gome"
  ,autohome: "autohome"
  ,fang: "fang"
  ,ctrip: "ctrip"
  ,yaoersanlingliu: "yaoersanlingliu"
  ,guazi: "guazi"
  ,qunar: "qunar"
  ,booking: "booking"
  ,tuniu: "tuniu"
  ,mafengwo: "mafengwo"
  ,feizhu: "feizhu"
  ,qidian: "qidian"
  ,jinjiang: "jinjiang"
  ,pconline: "pconline"
  ,ithome: "ithome"
  ,zealer: "zealer"
  ,huya: "huya"
  ,longzhu: "longzhu"
  ,ganji: "ganji"
  ,baixing: "baixing"
  ,beike: "beike"
  ,lianjia: "lianjia"
  ,woaiwojia: "woaiwojia"
  ,meituan: "meituan"
  ,huajun: "huajun"
  ,qianchengwuyou: "qianchengwuyou"
  ,lagou: "lagou"
  ,mailqq: "mailqq"
  ,mailsina: "mailsina"
  ,xiachufang: "xiachufang"
  ,qiushibaike: "qiushibaike"
  ,tianyancha: "tianyancha"
  ,netstudy: "netstudy"
  ,imooc: "imooc"
  ,qqweb: "qqweb"
  ,weixinweb: "weixinweb"
  ,tencentcloud: "tencentcloud"
  ,aws: "aws"
  ,azure: "azure"
  ,googlecloud: "googlecloud"
  ,anjuke: "anjuke"
  ,bcy: "bcy"
  ,guoguo: "guoguo"
  ,dianxin: "dianxin"
  ,yidong: "yidong"
  ,liantong: "liantong"
  ,gaode: "gaode"
  ,baidumap: "baidumap"
  ,tencentmap: "tencentmap"
  ,googlemap: "googlemap"
  ,didi: "didi"
  ,eleme: "eleme"
  ,meituanwaimai: "meituanwaimai"
  ,koubei: "koubei"
  ,gmail: "gmail"
  ,baidutranslate: "baidutranslate"
  ,youdaotranslate: "youdaotranslate"
  ,ximalaya: "ximalaya"
  ,weibo: "weibo"
  ,guoke: "guoke"
  ,tencentstudy: "tencentstudy"






}
export default inputKey



// WEBPACK FOOTER //
// ./src/cnConst/inputKey.js